import { Link } from "react-router-dom";

export function AuthShell({ eyebrow, title, children, footer }) {
  return (
    <div className="container-x grid min-h-[calc(100vh-4rem)] items-center gap-12 py-16 lg:grid-cols-12">
      <div className="hidden lg:col-span-6 lg:block">
        <div className="relative overflow-hidden rounded-2xl border border-amber-900/40">
          <img src="/images/forge.jpg" alt="Arcane sigils glowing in the dark" className="h-[520px] w-full object-cover opacity-80" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0D12] via-[#0B0D12]/40 to-transparent" />
          <div className="absolute bottom-8 left-8 right-8">
            <p className="eyebrow mb-3">The Foundry awaits</p>
            <p className="font-heading text-2xl text-amber-100">Forge your cards. Build your legends. Shape the multiverse.</p>
          </div>
        </div>
      </div>
      <div className="mx-auto w-full max-w-md lg:col-span-5 lg:col-start-8">
        <p className="eyebrow mb-3">{eyebrow}</p>
        <h1 className="mb-8 font-heading text-3xl font-bold text-amber-100">{title}</h1>
        {children}
        {footer && <div className="mt-8 text-sm text-slate-400">{footer}</div>}
      </div>
    </div>
  );
}

export function GoogleButton() {
  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={start} className="btn-outline w-full" data-testid="google-login-button">
      <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden>
        <path fill="#FBBF24" d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.7 3-4.3 3-7.3z" />
        <path fill="#F59E0B" d="M12 22c2.7 0 5-.9 6.6-2.4l-3.2-2.5c-.9.6-2 1-3.4 1-2.6 0-4.8-1.8-5.6-4.1H3.1v2.6A10 10 0 0 0 12 22z" />
        <path fill="#D97706" d="M6.4 14c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2V7.4H3.1a10 10 0 0 0 0 9.2L6.4 14z" />
        <path fill="#FDE68A" d="M12 5.9c1.5 0 2.8.5 3.8 1.5l2.9-2.9A10 10 0 0 0 3.1 7.4L6.4 10C7.2 7.7 9.4 5.9 12 5.9z" />
      </svg>
      Continue with Google
    </button>
  );
}

export function Divider() {
  return (
    <div className="my-6 flex items-center gap-3 text-xs uppercase tracking-widest text-slate-500">
      <span className="h-px flex-1 bg-[#2A3447]" />or<span className="h-px flex-1 bg-[#2A3447]" />
    </div>
  );
}

export const AuthLink = ({ to, children, testid }) => (
  <Link to={to} className="font-semibold text-amber-300 hover:text-amber-200" data-testid={testid}>{children}</Link>
);
